import { Observable } from "rxjs"
import { ApiResponse } from "./types.domain"

export interface ApplicationNotes {
  ApplicationNotesId: number,
  UserId: number,
  ApplicationId: number,
  Name:string,
  Email:string,
  DateGenerated: string,
  Title: string | null,
  Note: string,
  visibleToInternalStaff: boolean,
  creditNote: boolean,
  // set when the note creation also sent email notifications; such notes are not editable so the
  // record of what was communicated stays intact
  NotificationSubmitter: string | null,
  DocumentConditionDetail: string | null,
}

export type RemoveApplicationNoteByNoteIdFn = (noteId: number) => Observable<ApiResponse>

export interface UpdateApplicationNoteBody {
  ApplicationNotesId: number,
  Title: string | null,
  Note: string,
}

export type UpdateApplicationNoteFn = (data: UpdateApplicationNoteBody) => Observable<ApiResponse>

